'use client'
import React, { useState, useEffect } from 'react'
import { useAuth } from '@/context/AuthContext';
import getToken from '@/hook/getToken';
import { Logout } from '@/components/auth/Logout';
import BASE_URL from '@/components/constants';
import Link from 'next/link';
const SignButton = () => {
    const [userName, setUserName] = useState('');
    const { isSignInOpen, setIsSignInOpen } = useAuth();
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const accessToken = getToken();
                if (!accessToken) return;
                // Replace with your actual access token
                const response = await fetch(`${BASE_URL}/v1/auth/b2c/me`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    let userName;

                    if (data.userDetails.name) {
                        userName = data.userDetails.name;
                    } else {
                        // Hardcoded username if name is not available
                        userName = 'User';
                    }

                    setUserName(userName);
                } else {
                    localStorage.removeItem('access_token');
                    console.error('Failed to fetch data:', response.status);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, [isSignInOpen]);
    const handlePopupOpen = () => {
        setIsPopupOpen(true);
    };

    const handlePopupClose = () => {
        setIsPopupOpen(false);
    };
    return (
        <div> {userName ? (
            <div
                className='mx-1 border-[#1D1D1F] px-2 py-1.5 text-sm font-medium capitalize'
                onMouseEnter={handlePopupOpen}
                onMouseLeave={handlePopupClose}
            >
                <span className='cursor-pointer whitespace-nowrap'>
                    {userName === undefined
                        ? 'User'
                        : `Hi, ${userName}` || 'Hi,User'}
                </span>
                {isPopupOpen && (
                    <div
                        className='absolute z-50 right-0 top-7  border border-gray-300 bg-white p-2'
                        onMouseEnter={handlePopupOpen}
                        onMouseLeave={handlePopupClose}
                    >
                        <button className='mb-2 block w-full text-left'>
                            <Link href='/user'>My Account</Link>
                        </button>
                        <button
                            className='block w-full text-left'
                            onClick={() => toast.success('Logout successful')}
                        >
                            <Logout />
                        </button>
                    </div>
                )}
            </div>
        ) : (
            <div
                className='whitespace-nowrap mx-1 cursor-pointer rounded-md border-2 border-[#1D1D1F] px-4 py-1.5 text-sm font-medium'
                onClick={() => setIsSignInOpen(true)}
            >
                Sign In
            </div>
        )}</div>
    )
}

export default SignButton